import { render, staticRenderFns } from "./form.search.medecin.vue?vue&type=template&id=0ff3f54e&scoped=true&"
import script from "./form.search.medecin.vue?vue&type=script&lang=js&"
export * from "./form.search.medecin.vue?vue&type=script&lang=js&"
import style0 from "./form.search.medecin.vue?vue&type=style&index=0&id=0ff3f54e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3f54e",
  null
  
)

export default component.exports